const $ = jQuery.noConflict();

class CalendarFilters {
    constructor() {
        this.filtersTrigger = $('.type-filters-trigger');
        this.filtersWrapper = $('.additional-filters');
    }
    init() {
        this.openClose();
    }
    openClose() {
        $(this.filtersTrigger).on('click', (e) => {
            const linkedFilters = $(e.currentTarget).parent().parent().find(this.filtersWrapper);
            if ($(e.currentTarget).hasClass('active')) {
                $(e.currentTarget).removeClass('active');
                $(linkedFilters).slideUp();
                return;
            }
            $(e.currentTarget).addClass('active');
            $(linkedFilters).slideDown();
        });
    }
}
export default new CalendarFilters();
